module.exports = __webpack_public_path__ + "static/media/social3.1c0a422d.png";